import Button from '@jetbrains/ring-ui/components/button/button'
import classNames from 'classnames'
import * as React from 'react'

import {getAgentHref} from '../../../../../routes'
import AgentLink from '../../../../common/AgentLink/AgentLink'
import type {AgentsTreeAgentNode} from '../../AgentsSidebar/AgentsSidebar.types'

import DisconnectionComment from './DisconnectionComment/DisconnectionComment'

import styles from './AgentListView.css'

// The purpose of this component is to render a placeholder based on agent preview data
// until the full data has been loaded.
function UnauthorizedAgentPlaceholderListView({
  className,
  ...agentNode
}: AgentsTreeAgentNode & {
  className?: string
}) {
  const {id, connected, name, osType, ip} = agentNode
  return (
    <div className={classNames(className, styles.agent, styles.loading)}>
      <AgentLink
        isSakuraUI
        href={getAgentHref(id)}
        agentId={id}
        name={name}
        osType={osType}
        className={styles.link}
      />
      {!connected && <DisconnectionComment className={styles.disconnectionComment} />}
      <div className={styles.split} />
      <div>{ip}</div>
      <div className={styles.authorize}>
        <Button disabled>{'Authorize...'}</Button>
      </div>
    </div>
  )
}

export default UnauthorizedAgentPlaceholderListView
